<div
  class="avatar g-flex g-flex__item-fixed g-flex--align-center g-flex--justify-center"
  [style.width]="customWidth"
  [style.height]="customHeight"
  (click)="editLogo.emit()">
  @switch (type) {
    @case ('default') {
      <img
        class="avatar__bg"
        [style.width]="customWidth"
        [style.height]="customHeight"
        src="assets/images/ui/guilds/guild-avatar-bg.avif"
        alt="" />
    }
    @case ('small') {
      <img
        class="avatar__bg"
        [style.width]="customWidth"
        [style.height]="customHeight"
        src="assets/images/ui/guilds/guild-avatar-bg-small.png"
        alt="" />
    }
  }

  <div
    class="avatar__mask g-flex g-flex--align-center g-flex--justify-center"
    [class.avatar__mask--default]="type === 'default'"
    [style.width]="customWidth"
    [style.height]="customWidth ? 'auto' : null"
    [style.mask-size]="customMaskSize ? customMaskSize : '102px'">
    <img
      class="avatar__img"
      [style.width]="customWidth"
      [style.height]="customWidth ? 'auto' : null"
      [src]="logoUrl || 'assets/images/ui/guilds/guild-avatar.avif'"
      alt="" />
  </div>
</div>
